import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "exportModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exportModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Exportera faktureringsunderlag")
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Välj utgåva att exportera annonsbokning för:", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Annonsbokningar", -1)
const _hoisted_12 = { class: "row mt-3 mb-3" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "filter-header" }
const _hoisted_17 = { class: "filter-header" }
const _hoisted_18 = { class: "filter-header" }
const _hoisted_19 = { class: "filter-header" }
const _hoisted_20 = { class: "filter-header" }
const _hoisted_21 = { class: "filter-header" }
const _hoisted_22 = { class: "filter-header" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "År"),
  /*#__PURE__*/_createElementVNode("th", null, "Utgåva"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Annonsör"),
  /*#__PURE__*/_createElementVNode("th", null, "Format"),
  /*#__PURE__*/_createElementVNode("th", null, "Listpris"),
  /*#__PURE__*/_createElementVNode("th", null, "Rabatt"),
  /*#__PURE__*/_createElementVNode("th", null, "Annonspris"),
  /*#__PURE__*/_createElementVNode("th", null, "Kommentar"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_27 = { class: "nowrap" }
const _hoisted_28 = { class: "nowrap" }
const _hoisted_29 = { class: "nowrap" }
const _hoisted_30 = { class: "nowrap" }
const _hoisted_31 = { class: "btn-group" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loadspinner = _resolveComponent("loadspinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multi_filter_selector = _resolveComponent("multi-filter-selector")!
  const _component_sorter_direction = _resolveComponent("sorter-direction")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.editionIdToExportAdBookingsFor) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editions, (edition, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: edition.editionId,
                  key: index
                }, _toDisplayString(edition.editionName), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.state.editionIdToExportAdBookingsFor]
            ]),
            _createVNode(_component_loadspinner, {
              message: "Genererar export...",
              loading: _ctx.state.exportingData
            }, null, 8, ["loading"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary btn-sm",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleExportModal(false))),
              disabled: _ctx.state.exportingData
            }, " Stäng ", 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportBookingsToExcel && _ctx.exportBookingsToExcel(...args))),
              disabled: _ctx.state.exportingData
            }, " Exportera ", 8, _hoisted_10)
          ])
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary btn-sm",
          to: "/mgmt/advertising/createAdBooking"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Lägg till annonsbokning")
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-sm ms-3",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleExportModal(true)))
        }, " Faktureringsunderlag ")
      ])
    ]),
    _createElementVNode("table", _hoisted_14, [
      _createElementVNode("thead", null, [
        (_ctx.bookings)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
              _createElementVNode("th", _hoisted_16, [
                _createVNode(_component_multi_filter_selector, {
                  items: _ctx.bookings,
                  field: "year",
                  selected: _ctx.filters.year,
                  onChanged: _ctx.filterApplied
                }, null, 8, ["items", "selected", "onChanged"]),
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "year",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_17, [
                _createVNode(_component_multi_filter_selector, {
                  items: _ctx.bookings,
                  field: "edition",
                  selected: _ctx.filters.edition,
                  onChanged: _ctx.filterApplied
                }, null, 8, ["items", "selected", "onChanged"]),
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "edition",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_18, [
                _createVNode(_component_multi_filter_selector, {
                  items: _ctx.bookings,
                  field: "status",
                  selected: _ctx.filters.status,
                  onChanged: _ctx.filterApplied
                }, null, 8, ["items", "selected", "onChanged"]),
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "status",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_19, [
                _createVNode(_component_multi_filter_selector, {
                  items: _ctx.bookings,
                  field: "advertiser",
                  selected: _ctx.filters.advertiser,
                  onChanged: _ctx.filterApplied
                }, null, 8, ["items", "selected", "onChanged"]),
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "advertiser",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_20, [
                _createVNode(_component_multi_filter_selector, {
                  items: _ctx.bookings,
                  field: "format",
                  selected: _ctx.filters.format,
                  onChanged: _ctx.filterApplied
                }, null, 8, ["items", "selected", "onChanged"]),
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "format",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_21, [
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "listPrice",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _createElementVNode("th", _hoisted_22, [
                _createVNode(_component_sorter_direction, {
                  onChanged: _ctx.sortOrderApplied,
                  field: "discount",
                  sorting: _ctx.sorting
                }, null, 8, ["onChanged", "sorting"])
              ]),
              _hoisted_23,
              _hoisted_24,
              _hoisted_25
            ]))
          : _createCommentVNode("", true),
        _hoisted_26
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBookings, (booking, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(booking.year), 1),
            _createElementVNode("td", null, _toDisplayString(booking.edition), 1),
            _createElementVNode("td", null, _toDisplayString(booking.status), 1),
            _createElementVNode("td", null, _toDisplayString(booking.advertiser), 1),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(booking.format), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(booking.listPrice) + " SEK", 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(booking.discount * 100) + "%", 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_30, _toDisplayString(Math.round(
                  booking.listPrice - booking.listPrice * booking.discount,
                  0
                )) + " SEK", 1)
            ]),
            _createElementVNode("td", null, _toDisplayString(booking.comment), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editAdBooking(booking.bookingId)),
                  class: "btn btn-sm btn-primary",
                  title: "Ändra annonsör"
                }, _hoisted_34, 8, _hoisted_32),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteAdvertiser(_ctx.advertiser))),
                  class: "btn btn-sm btn-danger",
                  title: "Ta bort annonsör"
                }, _hoisted_36)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}